import { useSessionStorage } from "@app/hooks/useLocalStorage";
import { CarPortfolioStatGroup } from "../usePortfolioGroupVersionData";
import { useMemo } from "react";

export const useInteractiveSimulationModeSelector = (props: {
  statGroups: CarPortfolioStatGroup[];
}) => {
  const [statRowIds, setStatRowIds] = useSessionStorage<string[]>(
    "useInteractiveSimulationModeSelector_statRowIds",
    [],
  );

  return useMemo(
    () => ({
      statRowIds,
      setStatRowIds,
      statGroups: props.statGroups,
      selectedStatRows: props.statGroups
        .flatMap((i) => i.rows)
        .filter((r) => statRowIds.includes(r.id)),
    }),
    [props.statGroups, setStatRowIds, statRowIds],
  );
};

export type UseInteractiveSimulationModeSelector = ReturnType<
  typeof useInteractiveSimulationModeSelector
>;
